/**
 * Registry icon names → lucide icons: a type's `icon`, a collection's `icon` and a view tile's
 * `icon` (lib/catalog/productTypes). One map; a new name is a new entry.
 */
import { Briefcase, Gamepad2, Laptop, Wallet, Cpu, LayoutGrid, Monitor, Smartphone, Tablet, Watch, Tv, Camera, Headphones, Cable, Package, MemoryStick, HardDrive, Shirt, Footprints, Gem } from 'lucide-react';

export const TYPE_ICONS = {
  briefcase: Briefcase, wallet: Wallet, cpu: Cpu, 'memory-stick': MemoryStick, 'hard-drive': HardDrive, 'layout-grid': LayoutGrid,
  laptop: Laptop, monitor: Monitor, smartphone: Smartphone, tablet: Tablet, watch: Watch, tv: Tv, camera: Camera,
  headphones: Headphones, 'gamepad-2': Gamepad2, cable: Cable, package: Package,
  shirt: Shirt, footprints: Footprints, gem: Gem,
};

export const iconFor = (name, fallback = Package) => TYPE_ICONS[name] || fallback;
